import { Card, CardContent, Stack, Typography } from "@mui/joy";
import { Link } from "react-router";
import { CryptoCurrencyFormat, CurrencyFormat } from "../config/services";
import styles from "./SendCoinItem.module.css";

const SendCoinItem = ({ coin }) => {
  const { image, coinname, balance, balancecoin, thumbimage, code } = coin;
  return (
    <Link to="/send" state={coin} style={{ textDecoration: "none" }}>
      <Card variant="outlined">
        <CardContent>
          <Stack direction={"row"} spacing={2} justifyContent={"space-between"}>
            <div className={styles.frameParent}>
              <div
                className={styles.frame}
                style={{ backgroundImage: `url(${image})` }}
              >
                <img className={styles.imageIcon} alt="" src={thumbimage} />
              </div>
              <div className={styles.frame1}>
                <Typography level="body-lg">{coinname}</Typography>
              </div>
            </div>
            <div className={styles.frame2}>
              <div className={styles.frame3}>
                <Typography level="body-md">
                  {balance == 0 ? (
                    `0.00`
                  ) : (
                    <CryptoCurrencyFormat amount={balancecoin} />
                  )}
                </Typography>
              </div>
              <div>
                <CurrencyFormat amount={balance} prefix="$" seperator={true} />
              </div>
            </div>
          </Stack>
        </CardContent>
      </Card>
    </Link>
  );
};

export default SendCoinItem;
